import i18n from "@/i18n.ts";
import { Rule, RuleApplySignType, RuleConditionType, RuleGroup } from "@/types/rule.types.ts";
import { SelectItem } from "@skailer-com/uikit";

export type RuleGroupingPreset = "match_all" | "match_any" | "custom_groups";

export const ruleGroupingPresetOptions = (): SelectItem[] => {
  return [
    { id: "match_all", title: i18n.t("core:rule_group_mode_all") },
    { id: "match_any", title: i18n.t("core:rule_group_mode_any") },
    { id: "custom_groups", title: i18n.t("core:rule_group_mode_combination") },
  ];
};

export const detectGroupingPreset = (groups: RuleGroup[]): RuleGroupingPreset => {
  if (groups.length <= 1) return "match_all";
  if (groups.every((group) => group.rules.length === 1)) return "match_any";
  return "custom_groups";
};

export const flattenRuleGroups = (groups: RuleGroup[]): Rule[] =>
  groups.flatMap((group) => group.rules);

export const groupRulesByPreset = (rules: Rule[], preset: RuleGroupingPreset): RuleGroup[] => {
  if (preset === "match_any") return rules.map((rule) => ({ rules: [rule] }));
  return rules.length ? [{ rules }] : [];
};

export const allEmployeesRuleGroups = () => [
  {
    rules: [
      {
        condition_type: RuleConditionType.organization,
        sign: RuleApplySignType.include,
        condition_ids: [] as (string | number)[],
        value_ids: [] as (string | number)[],
        condition_entities: [],
        value_entities: [],
      },
    ],
  },
];

export const isAllEmployeesRuleGroups = (groups?: RuleGroup[]) => {
  const rules = (groups ?? []).flatMap((group) => group.rules ?? []);
  return rules.length === 1 && rules[0].condition_type === RuleConditionType.organization;
};
